"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._pprepend = void 0;
var IRNative_1 = require("../../../../IR/IRNodes/IRNative/index.js");
var Term_1 = require("../../../Term/index.js");
var type_system_1 = require("../../../type_system/index.js");
function _pprepend(listElemType) {
    var listElemT = listElemType;
    return new Term_1.Term((0, type_system_1.fn)([listElemT, (0, type_system_1.list)(listElemT)], (0, type_system_1.list)(listElemT)), function (_dbn) { return IRNative_1.IRNative.mkCons; });
}
exports._pprepend = _pprepend;
